// =============================
// File: PermissionListPage.jsx
// =============================
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import Filter from "./PermissionFilter";
import Pagination from "./PermissionPagination";
import RowAction from "./PermissionRowAction";
import CreateDrawer from "./PermissionCreateDrawer";
import {
  getPermissions,
  createPermission,
  updatePermission,
  deletePermission,
} from "../../../api/settings/permissions/permissionList";

const PermissionListPage = () => {
  const [permissions, setPermissions] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({ keyword: "", module_id: "", is_active: "" });

  const fetchData = async (override = {}) => {
    try {
      const params = {
        page: currentPage,
        pageSize,
        ...filters,
        ...override,
      };
      const res = await getPermissions(params);
      // Try to normalize common API shapes
      const items = res?.data?.items ?? res?.data?.results ?? res?.data ?? [];
      const total = res?.data?.total ?? res?.total ?? (Array.isArray(items) ? items.length : 0);
      setPermissions(items);
      setTotalRecords(total);
    } catch (err) {
      console.error("Lỗi khi tải danh sách quyền:", err);
      setPermissions([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, filters]);

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">Permission List</h1>

      <Filter
        onNewClick={() => {
          setSelectedPermission(null);
          setShowDrawer(true);
        }}
        onFilterChange={(f) => {
          setFilters(f);
          setCurrentPage(1); // reset về trang 1 khi đổi filter
        }}
      />

      {/* <div className="border rounded-md overflow-x-auto">
        <table className="w-full table-auto text-sm bg-white">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-2">Code</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Modules / Functions</th>
              <th className="px-3 py-2">Description</th>
              <th className="px-3 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {permissions.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-4 text-gray-500">
                  Không có dữ liệu.
                </td>
              </tr>
            ) : (
              permissions.map((item) => (
                <tr key={item.code} className="border-t hover:bg-gray-50">
                  <td className="px-3 py-2">{item.code}</td>
                  <td className="px-3 py-2">{item.name}</td>
                  <td className="px-3 py-2">{item.module_id}</td>
                  <td className="px-3 py-2">{item.description}</td>
                  <td className="px-3 py-2">
                    <RowAction
                      data={item}
                      onEdit={() => {
                        setSelectedPermission(item);
                        setShowDrawer(true);
                      }}
                      onDeleted={() => fetchData()}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div> */}

<div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
  <div className="overflow-x-auto">
    <table className="w-full text-left border-collapse">
      {/* Header đồng bộ style Black/Uppercase */}
      <thead className="bg-gray-50/50 border-b border-gray-100">
        <tr>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest w-16 text-center">STT</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Mã Quyền</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Tên Chức Năng</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest text-center">Module</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Mô tả hệ thống</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest text-center">Hành động</th>
        </tr>
      </thead>

      {/* Body với hiệu ứng Group Hover */}
      <tbody className="divide-y divide-gray-50">
        {permissions.length === 0 ? (
          <tr>
            <td colSpan={6} className="p-20 text-center">
              <div className="flex flex-col items-center gap-3">
                <div className="w-16 h-16 rounded-3xl bg-gray-50 flex items-center justify-center border-2 border-dashed border-gray-200 text-gray-300">
                  <FontAwesomeIcon icon={faBoxOpen} size="lg" />
                </div>
                <p className="text-gray-400 font-black italic uppercase text-xs tracking-widest">
                  Không tìm thấy dữ liệu quyền
                </p>
              </div>
            </td>
          </tr>
        ) : (
          permissions.map((item, index) => (
            <tr key={item.code} className="hover:bg-red-50/30 transition-colors group">
              {/* STT */}
              <td className="p-5 text-center">
                <span className="text-xs font-bold text-gray-400">
                  {index + 1}
                </span>
              </td>

              {/* Code: Badge Tech Style */}
              <td className="p-5">
                <span className="px-3 py-1 bg-slate-100 text-slate-600 rounded-lg text-[10px] font-black uppercase tracking-tighter border border-slate-200 font-mono">
                  {item.code}
                </span>
              </td>

              {/* Name: Font Black & Hover Red */}
              <td className="p-5">
                <p className="font-black text-gray-800 text-sm group-hover:text-red-700 transition-colors">
                  {item.name}
                </p>
              </td>

              {/* Module: Colored Badge */}
              <td className="p-5 text-center">
                <span className="px-3 py-1 bg-white border border-gray-200 text-gray-500 rounded-xl text-[10px] font-black uppercase tracking-widest shadow-sm">
                  {item.module_id}
                </span>
              </td>

              {/* Description: Italic Medium */}
              <td className="p-5">
                <p className="text-xs font-medium text-gray-500 italic leading-relaxed line-clamp-1 max-w-[250px]">
                  {item.description || "—"}
                </p>
              </td>

              {/* Actions */}
              <td className="p-5">
                <div className="flex justify-center items-center">
                  <RowAction
                    data={item}
                    onEdit={() => {
                      setSelectedPermission(item);
                      setShowDrawer(true);
                    }}
                    onDeleted={() => fetchData()}
                  />
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</div>

      <Pagination
        totalRecords={totalRecords}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
      />

      <CreateDrawer
        isOpen={showDrawer}
        onClose={() => setShowDrawer(false)}
        data={selectedPermission}
        onSaved={() => {
          fetchData();
          setShowDrawer(false);
        }}
      />
    </div>
  );
};

export default PermissionListPage;